module.exports = __webpack_public_path__ + "static/media/questionGraph.591cfd75.png";